import { MdEdit } from "react-icons/md";
import useModal from "../../hooks/useModal";
import { Container, IconContainer } from "./style";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";

interface ActionsProps {
  id: string;
  record: any;
}

function Actions({ id, record }: ActionsProps) {
  const { setIsEditing, setIsOpen, setId, setRecord } = useModal();

  const { hasPermission } = useValidatePermission();

  const isEditModalVisible = hasPermission(["NotificacaoJustificativas.Editar"]);

  const handleOpenEditModal = () => {
    if (isEditModalVisible) {
      setIsEditing(true);
      setId(id);
      setIsOpen(true);
      setRecord(record);
    }
  }

  return (
    <Container>
      <IconContainer isActive={isEditModalVisible}>
        <MdEdit size={18} color="#757575" onClick={handleOpenEditModal} />
      </IconContainer>
    </Container>
  );
}

export default Actions;
